<template>
  <form @submit.prevent="submitHandler">

    <div class="alert alert-danger text-center" v-if="errMsg">
      {{ errMsg }}
    </div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label col-form-label-sm">First name</label>
      <div class="col-sm-10">
        <input type="text"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': !$v.formData.firstName.required && $v.formData.firstName.$dirty }]"
          placeholder="First name"
          @blur="$v.formData.firstName.$touch()"
          v-model="formData.firstName">
        <div class="invalid-feedback">
          Please, enter user first name.
        </div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label col-form-label-sm">Last name</label>
      <div class="col-sm-10">
        <input type="text"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': !$v.formData.lastName.required && $v.formData.lastName.$dirty }]"
          placeholder="Last name"
          @blur="$v.formData.lastName.$touch()"
          v-model="formData.lastName">
        <div class="invalid-feedback">
          Please, enter user last name.
        </div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label col-form-label-sm">Email</label>
      <div class="col-sm-10">
        <input type="text"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': (!$v.formData.email.required && $v.formData.email.$dirty) || !$v.formData.email.email }]"
          placeholder="Email"
          @blur="$v.formData.email.$touch()"
          v-model="formData.email">
        <div class="invalid-feedback">
          {{ $v.formData.email.required ? 'Please, enter valid email' : 'Please, enter user email' }}
        </div>
      </div>
    </div>

    <button type="submit" class="btn btn-lg btn-block btn-success" :disabled="$v.formData.$invalid">Create User</button>

    <loading :loading="loading"></loading>

  </form>
</template>


<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
  validations: {
    formData: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      email: {
        required,
        email,
      },
    },
  },
  data() {
    return {
      formData: {
        firstName: null,
        lastName: null,
        email: null,
      },
      loading: false,
      errMsg: null,
    }
  },
  methods: {
    submitHandler() {
      if (!this.$v.formData.$invalid) {
        this.loading = true
        this.$store.dispatch('createUser', this.formData)
          .then(() => {
            this.$emit('createSuccess')
          })
          .catch(err => {
            if (err.response.status === 400) {
              this.errMsg = 'Email already exist'
            } else {
              this.errMsg = 'OOPSS! Something goes wrong. Try again.'
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/components/forms/CreateUserForm.vue